import { useMemo } from "react"

import { CURRENCY } from "utils/constants"
import { useGetPrice } from "modules/Payment/common/hooks"
import { usePaymentContext } from "modules/Payment/PaymentContext"
import { useApi } from "modules/Payment/FormPage/common/hooks"
import { Button } from "ui-kit/components-branded/index"
import { NETWORK_ERROR_MESSAGE } from "modules/BookingCommon/common/constants"

export function NextPageButton() {
    const [{ payByCard, currency, errorMessage, bookSessionIsLoading }] = usePaymentContext()
    const [, discountPrice] = useGetPrice()

    const isAutoPay = useMemo(() => {
        return !!payByCard?.external_id && currency === CURRENCY.RUB
    }, [payByCard?.external_id, currency])

    const { submitToPayment } = useApi(isAutoPay)

    const goToPaymentText = useMemo(() => {
        if (discountPrice === 0) {
            return "Записаться"
        } else {
            return isAutoPay ? "Оплатить" : "Перейти к оплате"
        }
    }, [discountPrice, isAutoPay])

    return (
        <>
            <Button
                color="primary"
                isFullwidth
                onClick={() => {
                    void submitToPayment()
                }}
                disabled={bookSessionIsLoading}
            >
                {goToPaymentText}
            </Button>
            {errorMessage && (
                <div className="booking__error-text">{errorMessage || NETWORK_ERROR_MESSAGE}</div>
            )}
        </>
    )
}
